import Owner from './Owner';

export default Owner;
